import React from "react";
import { toast } from "react-toastify";
// Common Components
import {
  Modal,
  TextInput,
  DynamicDropdown,
  DynamicMultiSelectDropdown,
  Button,
  Table,
} from "src/Components";
import { TableCell, TableRow } from "@mui/material";
// Services
import {
  addIsinsGroup,
  getAssetTypeDropDown,
  getPortfolioGroupDropDown,
  getInstrumentsDropDown,
} from "src/Requests/portfolioGroups";
// Types
import {
  IAddIsinsGroupResult,
  IIsinsGroupSearchParams,
} from "src/Interfaces/portfolioGroups";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onSuccess: () => void;
  onClose: () => void;
}
const AddSymbolModal: React.FC<IProps> = ({ onSuccess, onClose }) => {
  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [result, setResult] = React.useState<IAddIsinsGroupResult | null>(null);
  const [formValues, setFormValues] = React.useState<IIsinsGroupSearchParams>({
    portfoGroupIds: [],
    assetType: "",
    isins: [],
    minValue: 0,
    maxValue: 100,
  });

  const onChange = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      [name]: value,
      ...(name === "assetType" ? { isins: [] } : {}),
    });
  };

  const onPortfoGroupIdsChange = (name: string, value: any) => {
    setFormValues({
      ...formValues,
      [name]: Array.isArray(value) ? value.map(Number) : value,
    });
  };

  const onInstrumentChange = (_: string, value: any) => {
    setFormValues({
      ...formValues,
      isins: value ? [value] : [],
    });
  };

  const onClickHandler = () => {
    setLoading(true);
    addIsinsGroup(formValues)
      .then((result) => {
        if (result.data) {
          setResult(result.data);
          onSuccess();
          setModal(true);
        } else {
          toast.error(result.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  const closeResultModalHandler = () => {
    setModal(false);
    onClose();
  };

  const ResultModal = React.useMemo(
    () => (
      <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
        <h4>
          تعداد موفق: <span>{result?.successCount}</span>
        </h4>
        <h4>
          تعداد ناموفق:<span>{result?.failedCount}</span>
        </h4>
        <div className="border-2 border-blue-100 w-full">
          <Table
            header={<div />}
            body={
              <>
                <TableRow>
                  <TableCell>
                    <div className="text-sm font-bold">#</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm font-bold">نماد</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm font-bold">گروه پرتفو</div>
                  </TableCell>
                </TableRow>
                {result?.successResults?.map((item, index) => (
                  <TableRow>
                    <TableCell>
                      <div className="w-full text-center">{index + 1}</div>
                    </TableCell>
                    <TableCell>
                      <div className="w-full text-center">
                        {item.instrumentName ?? item.isin}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div>{item.portfoGroupName}</div>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            }
          />
        </div>
      </div>
    ),
    [result],
  );

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      {modal && (
        <Modal
          title="نتیجه افزودن نماد"
          onClose={closeResultModalHandler}
          UI={ResultModal}
          closeOnBackdropClick
        />
      )}
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "portfoGroupIds",
          placeholder: "گروه پرتفو",
          extraLabel: true,
        }}
        getData={getPortfolioGroupDropDown}
        onChange={onPortfoGroupIdsChange}
        value={formValues.portfoGroupIds}
      />
      <DynamicDropdown
        dropdown={{
          name: "assetType",
          placeholder: "طبقه دارایی / استراتژی",
          extraLabel: true,
        }}
        getData={getAssetTypeDropDown}
        onChange={onChange}
        value={formValues.assetType}
      />
      {formValues.assetType ? (
        <DynamicDropdown
          dropdown={{
            name: "isins",
            placeholder: "نماد",
            extraLabel: true,
          }}
          getData={() => getInstrumentsDropDown(formValues.assetType)}
          onChange={onInstrumentChange}
          inputId={formValues.assetType}
          value={formValues.isins[0] ?? ""}
        />
      ) : null}
      <TextInput
        name="minValue"
        label="٪ کف"
        onChange={onChange}
        value={formValues.minValue.toString()}
        extraLabel
      />
      <TextInput
        name="maxValue"
        label="٪ سقف"
        onChange={onChange}
        value={formValues.maxValue.toString()}
        extraLabel
      />
      <Button
        text="افزودن"
        onClick={onClickHandler}
        variant="contained"
        loading={loading}
        disabled={
          !formValues.portfoGroupIds.length ||
          !formValues.assetType ||
          !formValues.isins.length
        }
      />
    </div>
  );
};

export default AddSymbolModal;
